import { render, staticRenderFns } from "./outpatienttreatment.vue?vue&type=template&id=0b6d6267&scoped=true"
import script from "./outpatienttreatment.vue?vue&type=script&lang=js"
export * from "./outpatienttreatment.vue?vue&type=script&lang=js"
import style0 from "./outpatienttreatment.vue?vue&type=style&index=0&id=0b6d6267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d6267",
  null
  
)

export default component.exports